import React, { useEffect, useRef } from "react";
import "./SideDrawerWapper.css";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Drawer, IconButton, Tooltip } from "@mui/material";
import SubmitButton from "components/Button/SubmitButton";

const SideDrawerWrapper = ({
  children,
  showDrawer,
  title,
  cancelButtonText,
  successButtonText,

  handleClose,
  handleCancel,
  handleSubmit,
  showFooter = true,
  disableConfirm = true,
  disableCancel = true,
  style = {},
}) => {
  const sidebarRef = useRef(null);

  useEffect(() => {
    handleSidebarToggle(showDrawer);
  }, [showDrawer]);

  const handleSidebarToggle = async (isOpen) => {
    if (sidebarRef.current) {
      sidebarRef.current.style.transition = "right 0.3s ease-in-out";
      sidebarRef.current.style.right = isOpen ? "0" : "-450px";
    }
  };

  const onClose = (e, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    handleClose && handleClose();
  };

  return (
    <Drawer
      ref={sidebarRef}
      anchor="right"
      open={showDrawer}
      onClose={handleClose}
      style={{ zIndex: 1301 }}
    >
      <div className="modal-dialog" style={style}>
        <div className="modal-header">
          {title && <div className="dialog-header__title">{title}</div>}

          <Tooltip title="Close" placement="bottom">
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div
          className="modal-content"
          // Fill the space below the header so only the body scrolls, and only when it overflows
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
            padding: 0,
          }}
        >
          <div
            className="modal-body"
            style={{ flex: 1, overflowY: "auto", padding: "24px" }}
          >
            {children}
          </div>

          {showFooter && (
            <div
              className="modal-footer d-flex justify-end"
              style={{
                position: "sticky",
                display: "flex",
                bottom: 0,
                background: "#fff",
                padding: "24px",
                alignItems: "center",
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                className="mr-2"
                onClick={handleCancel}
                disabled={disableCancel}
              >
                {cancelButtonText}
              </Button>
              <SubmitButton
                disabled={disableConfirm}
                buttonText={successButtonText}
                handleClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default SideDrawerWrapper;
